import Vue from 'vue'
import Axios from 'axios'
import  { ToastPlugin } from 'vux'
import { LoadingPlugin } from 'vux'
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Axios.defaults.headers.post['Content-Type'] = 'application/json';


const requestUni = function(opt) {
    var globalPostData={
        VendorKey:'325910d6237149409d6a42037a6bca0f',
        AppCode:'201905250001'
    }



    opt.api =opt.api || '/baobiao/';
    opt = opt || {};
    opt.url = opt.url || '';
    opt.data = opt.data || null;
    opt.method = opt.method || 'GET';

    opt.success = opt.success || function () {};
    opt.fail = opt.fail || function () {};
    var data= Object.assign(opt.data, globalPostData)
    console.log(data)
        if(opt.method=="POST"){

        Vue.$vux.loading.show({"text":"Loading"})

        Axios.post(opt.api+opt.url, data).then(function (response) {
            Vue.$vux.loading.hide()
            opt.success(response);
        }).catch(function (error) {
            // opt.fail(error);
            Vue.$vux.loading.hide()
            console.log(error);
            Vue.$vux.toast.show({
                type:'text',
                text: '网络链接失败，请重试'
            })

        });

    }else{
        Vue.$vux.loading.show({"text":"Loading"})
        Axios.get(opt.api+opt.url,{params:data}).then(function (response) {
            Vue.$vux.loading.hide()
            opt.success(response);
        }).catch(function (error) {
            Vue.$vux.loading.hide()
            // opt.fail(error);
            console.log(error);
            Vue.$vux.toast.show({
                type:'text',
                text: '网络链接失败，请重试'
            })

        });


    }




};
export default requestUni





//////////////////
// WEBPACK FOOTER
// ./static/js/request.js
// module id = null
// module chunks = 